module.exports = __webpack_public_path__ + "img/crown.53c0d087.svg";